import { createContext } from 'react';

const windowSizeContext = createContext();

export default windowSizeContext;